export default {
  WITH_CHECKBOX: 'WITH_CHECKBOX',
  WITHOUT_CHECKBOX: 'WITHOUT_CHECKBOX',
  FIXED_COLUMN: 'FIXED_COLUMN'
};